import React from 'react';

const FormLabel = (props: { title: string }) => {
  return <div style={{ marginBottom: 10, color: '#999' }}>{props.title}</div>;
};

export { FormLabel };
